export default "__VITE_ASSET__DJE4hmly__"